import {GeofenceEntryShiftTimelineEvent} from '@ots-frontend/ots-data';
import {ActionIcon, Text} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {IconCircle} from "@tabler/icons-react";
import {DefaultText} from '../../text/DefaultText/DefaultText';

type Props = {
  event: GeofenceEntryShiftTimelineEvent;
  onClick?: (event: GeofenceEntryShiftTimelineEvent) => void
};


export const GeofenceEntryTimelineItemTitle = (props: {}) => {
  const {t} = useTranslation(["common"])
  return <>{t("common.entity.shift.timeline.geofenceentry.title", "Entered Geofence")}</>
}

export const GeofenceEntryTimelineItemBullet = (props: Props) => {
  const {event, onClick} = props;

  if (onClick) {
    return (
      <ActionIcon variant="transparent" onClick={() => onClick(event)}>
        <IconCircle size={12}/>
      </ActionIcon>
    )
  } else {
    return (
      <IconCircle size={12}/>
    )
  }
}

export const GeofenceEntryTimelineItem = (props: Props) => {
  const {event} = props;

  return (
    <>
      <Text size="xs" mt={4}>
        <Text color="dimmed" size="sm">
          <DefaultText value={event.siteName}/>
        </Text>
        <FormattedDateTime date={event.date}/>
      </Text>
    </>
  );
};

GeofenceEntryTimelineItem.Title = GeofenceEntryTimelineItemTitle
GeofenceEntryTimelineItem.Bullet = GeofenceEntryTimelineItemBullet;
